import { render, staticRenderFns } from "./FormBox.vue?vue&type=template&id=c95cf05e&scoped=true&"
import script from "./FormBox.vue?vue&type=script&lang=js&"
export * from "./FormBox.vue?vue&type=script&lang=js&"
import style0 from "./FormBox.vue?vue&type=style&index=0&id=c95cf05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95cf05e",
  null
  
)

/* custom blocks */
import block0 from "./FormBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c95cf05e')) {
      api.createRecord('c95cf05e', component.options)
    } else {
      api.reload('c95cf05e', component.options)
    }
    module.hot.accept("./FormBox.vue?vue&type=template&id=c95cf05e&scoped=true&", function () {
      api.rerender('c95cf05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/FormBox.vue"
export default component.exports